import { createSearchParams } from 'react-router-dom';
import { getOperationAnalysisScopeQueryPatch } from './operation-analysis-scope';

export const buildStore360Path = (operationEntityId, { endDate, startDate } = {}) => {
  const searchParams = createSearchParams({
    ...getOperationAnalysisScopeQueryPatch({
      entityIds: [operationEntityId],
      type: 'entities',
    }),
    ...(startDate && endDate ? { endDate, startDate } : {}),
  });
  return `/stores/store-360?${searchParams}`;
};
